<template>
  <section class="container list-style02 mt-18">
    <h2 class="list-style02--tit">INSTAGRAM</h2>
    <ul class="row">
      <li
        v-for="item in instaList"
        :key="item.instagramUrl"
        class="col-6 col-md-3 list-style02--li"
      >
        <a :href="item.instagramUrl" target="_blank">
          <img :src="item.thumbnailUrl" alt="" />
        </a>
        <div class="list-style02--tag" :style="isNotHashTag(item.caption)">
          {{ hashStrings(item.caption) }}
        </div>
      </li>
    </ul>
    <div class="text-center mt-6">
      <a
        href="https://www.instagram.com/botalab.official"
        class="btn-style2"
        target="_blank"
        >공식 인스타 채널</a
      >
    </div>
  </section>
</template>

<script>

const HANGUL_JAMO_START = 4352;
const HANGUL_JAMO_END = 4546;
const HANGUL_JAMO_LENGTH_MULTIFIER = 2;

export default {
  name: 'Instargram',
  props: {
    instaList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    hashStrings(tag) {
      let hasJamo = false;

      const splited = tag.split('#');
      const gotyou = splited.reduce((acc, n) => {
        for (let i = 0; i < n.length; ++i) {
          const chCode = n[i].charCodeAt(0);
          if (chCode >= HANGUL_JAMO_START && chCode <= HANGUL_JAMO_END) {
            hasJamo = true;
            acc.push(n);
            break;
          }
        }

        return acc;
      }, []);

      if (hasJamo) {
        return tag.length >= 40 * HANGUL_JAMO_LENGTH_MULTIFIER ? `${tag.substr(0, 40 * HANGUL_JAMO_LENGTH_MULTIFIER)}...` : tag;
      }
      return tag.length >= 40 ? `${tag.substr(0, 40)}...` : tag;

      // item.caption.length >= 40 ? item.caption.substr(0,40) + '...' : item.caption
    },
    isNotHashTag(caption) {
      if (caption) {
        return '';
      }
      return 'display:none';
    },
  },
};
</script>
